import React, { useState } from 'react';

import styled from 'styled-components';

import NwIcon from '@components/Gui/NwIcon';
import InvoiceDrawer from '@components/InvoicesAndCreditNotes/InvoiceDrawer';
import PaymentDrawer from '@components/Payments/PaymentDrawer';
import StatementClientInvoiceStatusIcon from '@components/Transactions/StatementClientInvoiceStatusIcon';

import { getClientStatementStatus } from '../helpers';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    min-width: 4rem;
    min-height: 4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const ClientStatementStatusCell = ({
    transaction,
    small,
    additionalText,
    disableDetailOpen = false,
    detailContactType = 'model',
    invoiceDrawerProps,
    onInvoiceClose,
    onPaymentClose,
}) => {
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedPayment, setSelectedPayment] = useState(null);

    const handleOpenInvoice = (invoiceId) => {
        if (!disableDetailOpen && invoiceId) {
            setSelectedInvoice(invoiceId);
        }
    };

    const handleOpenPayment = (paymentId) => {
        if (!disableDetailOpen && paymentId) {
            setSelectedPayment(paymentId);
        }
    };

    const handleCloseInvoice = () => {
        setSelectedInvoice(null);
        if (typeof onInvoiceClose === 'function') {
            onInvoiceClose();
        }
    };

    const handleClosePayment = () => {
        setSelectedPayment(null);
        if (typeof onPaymentClose === 'function') {
            onPaymentClose();
        }
    };

    if (transaction?.isPayment) {
        const canOpenPayment = !disableDetailOpen;
        const handlePaymentClick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            handleOpenPayment(transaction.ID);
        };
        const className = 'transaction-status';

        return (
            <>
                <Wrapper className={className}>
                    <NwIcon
                        icon={byPrefixAndName.fasl['money-check-dollar-pen']}
                        pointer={canOpenPayment}
                        onClick={canOpenPayment ? handlePaymentClick : undefined}
                    />
                </Wrapper>
                {selectedPayment && (
                    <PaymentDrawer
                        paymentID={selectedPayment}
                        contactType={detailContactType}
                        onClose={handleClosePayment}
                    />
                )}
            </>
        );
    }

    const statusModel = getClientStatementStatus(transaction);

    return (
        <>
            <Wrapper className="transaction-status">
                <StatementClientInvoiceStatusIcon
                    transaction={transaction}
                    statusModel={statusModel}
                    onInvoiceClick={disableDetailOpen ? undefined : handleOpenInvoice}
                    small={small}
                    additionalText={additionalText}
                />
            </Wrapper>
            {selectedInvoice && (
                <InvoiceDrawer invoiceId={selectedInvoice} onClose={handleCloseInvoice} {...invoiceDrawerProps} />
            )}
        </>
    );
};

export default ClientStatementStatusCell;
